const DRIVER_ASSIST_SCENES = {
    propilot: 'ProPilot',
    propilotactive: 'ProPilotActive',
    parkassistactive: 'ParkAssistActive',
    remoteparking: 'RemoteParking',
    remoteparkingprologue: 'RemoteParkingPrologue',
    remoteparkingactive: 'RemoteParkingActive',
};
const DRIVER_ASSIST_SCENES_LIST = Object.keys(DRIVER_ASSIST_SCENES);
const DRIVER_ASSIST_SCENE_NAMES = ['ProPilot', 'ProPilotActive', 'ParkAssistActive', 'RemoteParking', 'RemoteParkingPrologue', 'RemoteParkingActive'];
let driverAssistMenuItemIndices = [];

const setDriverAssistMenuItemIndices = (itemName) => {
    const menuItemIndex = DRIVER_ASSIST_SCENES_LIST.findIndex((item) => item === itemName);
    driverAssistMenuItemIndices.push(menuItemIndex);
};

const getDriverAssistData = ({ driverAssistMenuData, driverAssistScenes }) => {
    driverAssistMenuItemIndices = [];

    driverAssistMenuData.forEach(({ name }) => {
        setDriverAssistMenuItemIndices(name);
    });

    const enabledDriverAssistScenes = driverAssistScenes
        .filter(({ scene, enabled }) => {
            return DRIVER_ASSIST_SCENE_NAMES.includes(scene) && enabled;
        })
        .map(({ scene }) => DRIVER_ASSIST_SCENES_LIST.find((item) => DRIVER_ASSIST_SCENES[item] === scene));

    const driverAssist = driverAssistMenuData.reduce(
        (current, item, i) => ({
            ...current,
            [item.name]: [...enabledDriverAssistScenes].slice(driverAssistMenuItemIndices[i], driverAssistMenuItemIndices[i + 1]),
        }),
        {}
    );

    return driverAssist;
};

const getScenesJourney = ({ driverAssistMenuData, driverAssistScenes }) => {
    const JOURNEY = {
        connectivity: {
            overview: ['overview', 'trip', 'route', 'charge'],
            'overview-home': ['overview-home', 'voiceassistant', 'defrost'],
            'overview-incar': ['overview-incar', 'inside'],
        },
        design: {
            lookaround: ['awaken', 'lookaround'],
            hotspots: ['hotspots'],
            exterior: ['exterior'],
        },
        performance: { comfort: ['engine', 'comfort'], handling: ['handling', 'handlingactive'] },
        driverAssist: driverAssistScenes && driverAssistMenuData ? getDriverAssistData({ driverAssistScenes, driverAssistMenuData }) : {},
    };

    return JOURNEY;
};

const NON_CONTRIBUTORS = ['overview', 'overview-home', 'overview-incar'];
const PROGRESS_EXCEPTIONS = ['exterior'];

export default getScenesJourney;
export { NON_CONTRIBUTORS, PROGRESS_EXCEPTIONS };
